import {
  IonButton,
  IonButtons,
  IonContent,
  IonIcon,
  IonPage,
  IonTitle,
  IonToolbar
} from "@ionic/react";
import HtmlFile from "../components/HtmlFile";
import { closeOutline } from "ionicons/icons";

interface Props {
  dismiss: () => void;
}

const TermsAndConditions: React.FC<Props> = ({ dismiss }) => {
  return (
    <IonPage>
      <IonContent fullscreen>
        <IonToolbar>
          <IonButtons slot="start">
            <IonButton color="dark" onClick={() => dismiss()}>
              <IonIcon icon={closeOutline} />
            </IonButton>
          </IonButtons>
          <IonTitle>Terms and Conditions</IonTitle>
        </IonToolbar>
        <HtmlFile htmlFilePath="../assets/templates/terms.html" />
        <IonButton
          expand="block"
          color="primary"
          type="submit"
          className="mx-6 mt-12 h-12 normal-case"
          onClick={() => dismiss()}
        >
          Close
        </IonButton>
      </IonContent>
    </IonPage>
  );
};

export default TermsAndConditions;
